import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import api from 'api';
import { parseQueryString, currentLanguage } from 'helpers';
import { setCurrentView } from 'store';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';

import Media from 'css/Media';

class FailedCheckout extends Component {

  componentDidMount() {

  }


  render() {
    return (
      <div>
        <Wrapper>
          <HeadMeta page={{
            yoast: {
              title: 'Checkout - Failed'
            }
          }} />

          <Container grid>
            <StyledGridElement
              colStart={{default: 1, s: 5}}
              colEnd={{default: 8, s: 20}}
            >
              <StyledHtml>
                {currentLanguage() === 'no' ?
                  `<h2>ʕ•͡ᴥ•ʔ Noe gikk feil under betaling. Sjekk eposten din, <a href="/checkout">prøv igjen</a>, eller gå til <a href="/">forsiden</a>.</h2>`
                  : `<h2>ʕ•͡ᴥ•ʔ Something went wrong during payment. Check your email, <a href="/checkout">the try again</a>, or go to the <a href="/">front page</a>.</h2>`}
              </StyledHtml>
            </StyledGridElement>
          </Container>
        </Wrapper>
        <Footer/>
      </div>
    );
  }
}

const actions = {
  setCurrentView,
}

export default connect(null, actions)(withRouter(FailedCheckout));

const Wrapper = styled.article`
    min-height: 70vh;
`

const StyledGridElement = styled(GridElement)`
    padding-top: 160px;

    ${Media.greaterThan('s')`
        padding-top: 220px;
    `}
`

const StyledHtml = styled(Html)`
    a {
        color: ${props => props.theme.colors.link};
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
`